import { render, staticRenderFns } from "./HospitalAdminList.vue?vue&type=template&id=6f527056&scoped=true"
import script from "./HospitalAdminList.vue?vue&type=script&lang=js"
export * from "./HospitalAdminList.vue?vue&type=script&lang=js"
import style0 from "./HospitalAdminList.vue?vue&type=style&index=0&id=6f527056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f527056",
  null
  
)

export default component.exports